import React from "react";
import { FaCheck } from "react-icons/fa";

const HotelDetailRoomList = ({ rooms, onBook, hotelPhotos, isMobile = false }) => {
    return (
        <div style={{ marginBottom: "30px" }}>
            <h3 style={{ fontSize: isMobile ? "1.2rem" : "1.4rem", fontWeight: "900", marginBottom: "20px", color: "#1a1a1a", letterSpacing: "-0.5px" }}>Available Room Types</h3>

            {rooms.map((room, idx) => {
                const getRoomImg = () => {
                    if (hotelPhotos && hotelPhotos.length > 0) {
                        const photo = hotelPhotos[idx % hotelPhotos.length] || hotelPhotos[0];
                        return photo.photoUrl || photo;
                    }
                    return "https://images.unsplash.com/photo-1590490360182-c33d57733427?w=800&auto=format&fit=crop&q=60";
                };

                const roomImg = getRoomImg();

                // Parse amenities from the DB comma-separated string
                const amenityList = room.amenities
                    ? room.amenities.split(",").map(a => a.trim()).filter(Boolean)
                    : [];

                // Build meta info row from real DB columns
                const metaParts = [];
                if (room.roomSize) metaParts.push(`📏 ${room.roomSize}`);
                if (room.bedType) metaParts.push(`🛏️ ${room.bedType}`);
                if (room.maxPersons) metaParts.push(`👥 Max ${room.maxPersons}`);

                const isAvailable = room.available !== false && room.availability !== false;

                return (
                    <div key={room.roomId} style={{
                        background: "#fff",
                        borderRadius: "16px",
                        border: "1px solid #eee",
                        boxShadow: "0 4px 15px rgba(0,0,0,0.04)",
                        marginBottom: "16px",
                        overflow: "hidden",
                        transition: "all 0.3s ease"
                    }}
                        onMouseEnter={e => {
                            e.currentTarget.style.transform = "translateY(-2px)";
                            e.currentTarget.style.boxShadow = "0 8px 25px rgba(0,0,0,0.08)";
                        }}
                        onMouseLeave={e => {
                            e.currentTarget.style.transform = "translateY(0)";
                            e.currentTarget.style.boxShadow = "0 4px 15px rgba(0,0,0,0.04)";
                        }}
                    >
                        {/* Recommendation Banner */}
                        <div style={{
                            background: "linear-gradient(90deg, #EE2E24, #FFC400)",
                            padding: isMobile ? "6px 10px" : "6px 20px",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            color: "#fff"
                        }}>
                            <span style={{ fontSize: isMobile ? "0.64rem" : "0.7rem", fontWeight: "900", letterSpacing: "0.5px" }}>TRIVANA RECOMMENDS</span>
                            <span style={{ fontSize: isMobile ? "0.68rem" : "0.75rem", fontWeight: "600" }}>TRIVANA EXCLUSIVE</span>
                        </div>

                        <div style={{ display: "flex", minHeight: isMobile ? "auto" : "220px", flexDirection: isMobile ? "column" : "row" }}>
                            {/* Room Image */}
                            <div style={{ width: isMobile ? "100%" : "260px", padding: isMobile ? "10px" : "12px", borderRight: isMobile ? "none" : "1px solid #f5f5f5", borderBottom: isMobile ? "1px solid #f5f5f5" : "none", display: "flex", flexDirection: "column" }}>
                                <div style={{ flex: 1, minHeight: isMobile ? "160px" : "unset", borderRadius: "10px", overflow: "hidden", position: "relative", boxShadow: "0 2px 8px rgba(0,0,0,0.1)" }}>
                                    <img
                                        src={roomImg}
                                        style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                        alt={room.roomType}
                                        onError={(e) => {
                                            if (!e.target.src.includes("unsplash")) {
                                                e.target.src = "https://images.unsplash.com/photo-1566073771259-6a8506099945?w=800";
                                            }
                                        }}
                                    />
                                    {hotelPhotos && hotelPhotos.length > 0 && (
                                        <div style={{
                                            position: "absolute",
                                            bottom: isMobile ? "6px" : "8px",
                                            left: isMobile ? "6px" : "8px",
                                            background: "rgba(255,255,255,0.9)",
                                            padding: isMobile ? "3px 8px" : "4px 10px",
                                            borderRadius: "6px",
                                            fontSize: isMobile ? "0.6rem" : "0.65rem",
                                            fontWeight: "800",
                                            color: "#EE2E24"
                                        }}>
                                            {hotelPhotos.length} PHOTOS
                                        </div>
                                    )}
                                </div>
                                <h4 style={{ fontSize: isMobile ? "0.95rem" : "1.1rem", fontWeight: "800", color: "#1a1a1a", marginTop: isMobile ? "10px" : "12px", marginBottom: "4px" }}>{room.roomType}</h4>
                                {metaParts.length > 0 && (
                                    <div style={{ display: "flex", flexWrap: "wrap", gap: "6px", color: "#777", fontSize: isMobile ? "0.7rem" : "0.75rem" }}>
                                        {metaParts.map((part, i) => (
                                            <span key={i}>{part}{i < metaParts.length - 1 ? " |" : ""}</span>
                                        ))}
                                    </div>
                                )}
                            </div>

                            {/* Room Amenities from DB */}
                            <div style={{ flex: 1, padding: isMobile ? "12px" : "20px", borderRight: isMobile ? "none" : "1px solid #f5f5f5", borderBottom: isMobile ? "1px solid #f5f5f5" : "none", display: "flex", flexDirection: "column" }}>
                                <h4 style={{ fontSize: isMobile ? "0.85rem" : "0.95rem", fontWeight: "800", color: "#333", marginBottom: isMobile ? "8px" : "12px" }}>Stay Includes:</h4>
                                {amenityList.length > 0 ? (
                                    <div style={{ display: "grid", gridTemplateColumns: isMobile ? "repeat(2, 1fr)" : "1fr 1fr", gap: isMobile ? "6px" : "8px" }}>
                                        {amenityList.map((inc, i) => (
                                            <div key={i} style={{ display: "flex", alignItems: "center", gap: isMobile ? "6px" : "8px", fontSize: isMobile ? "0.75rem" : "0.85rem", color: "#555" }}>
                                                <FaCheck color="#27ae60" size={isMobile ? 10 : 12} />
                                                <span style={{ textTransform: "capitalize" }}>{inc}</span>
                                            </div>
                                        ))}
                                    </div>
                                ) : (
                                    <p style={{ color: "#aaa", fontSize: "0.85rem", fontStyle: "italic" }}>Amenities details not listed.</p>
                                )}
                                {room.description ? (
                                    <div style={{ marginTop: isMobile ? "10px" : "auto", padding: isMobile ? "8px" : "10px", background: "#f8f9fa", border: "1px solid #eee", borderRadius: "8px", fontSize: isMobile ? "0.75rem" : "0.8rem", color: "#555", lineHeight: "1.5" }}>
                                        {room.description}
                                    </div>
                                ) : null}
                            </div>

                            {/* Pricing & Booking */}
                            <div style={{ width: isMobile ? "100%" : "200px", padding: isMobile ? "14px" : "20px", background: "#fafafa", display: "flex", flexDirection: isMobile ? "row" : "column", justifyContent: isMobile ? "space-between" : "center", alignItems: isMobile ? "center" : "flex-end", textAlign: isMobile ? "left" : "right" }}>
                                <div style={{ display: "flex", flexDirection: "column" }}>
                                    <div style={{ fontSize: isMobile ? "1.35rem" : "1.8rem", fontWeight: "900", color: "#1a1a1a", lineHeight: "1" }}>₹{room.pricePerNight}</div>
                                    <div style={{ fontSize: isMobile ? "0.7rem" : "0.75rem", color: "#666", marginBottom: isMobile ? "0" : "12px", marginTop: "4px" }}>per night</div>
                                </div>

                                <div style={{ width: isMobile ? "auto" : "100%", minWidth: isMobile ? "120px" : "unset" }}>
                                    <button
                                        onClick={() => isAvailable && onBook(room)}
                                        disabled={!isAvailable}
                                        style={{
                                            width: "100%",
                                            padding: isMobile ? "9px 16px" : "12px",
                                            background: isAvailable
                                                ? "linear-gradient(135deg, #EE2E24 0%, #FFC400 100%)"
                                                : "#ccc",
                                            color: "#fff",
                                            fontWeight: "800",
                                            border: "none",
                                            borderRadius: "10px",
                                            cursor: isAvailable ? "pointer" : "not-allowed",
                                            fontSize: isMobile ? "0.78rem" : "0.9rem",
                                            textTransform: "uppercase",
                                            boxShadow: isAvailable ? "0 4px 12px rgba(238, 46, 36, 0.2)" : "none",
                                            transition: "all 0.2s"
                                        }}
                                        onMouseEnter={e => { if (isAvailable) e.currentTarget.style.filter = "brightness(1.1)"; }}
                                        onMouseLeave={e => { e.currentTarget.style.filter = "none"; }}
                                    >
                                        {isAvailable ? "BOOK NOW" : "SOLD OUT"}
                                    </button>

                                    {!isMobile && room.floorNumber && (
                                        <div style={{ marginTop: "8px", fontSize: "0.7rem", color: "#aaa" }}>
                                            Floor {room.floorNumber}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default HotelDetailRoomList;
